export const ENV_NAME = process.env.REACT_APP_ENV_NAME